/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { forwardRef } from 'react';
import { Icon, IconProps } from './Icon';

const QuestionIcon = forwardRef<typeof Icon, IconProps>((props, ref) => (
  // @ts-ignore
  <Icon ref={ref} viewBox="0 0 17 17" {...props}>
    <path
      fillRule="nonzero"
      d="M8.5 0c2.335 0 4.335.833 6.001 2.499C16.167 4.165 17 6.165 17 8.5c0 2.348-.83 4.352-2.489 6.011C12.851 16.171 10.848 17 8.5 17c-2.348 0-4.352-.83-6.011-2.489C.829 12.851 0 10.848 0 8.5c0-2.348.83-4.352 2.489-6.011C4.149.829 6.152 0 8.5 0zM7.497 14.462c.275.275.61.413 1.003.413.394 0 .728-.138 1.003-.413.276-.276.414-.61.414-1.004 0-.393-.138-.728-.414-1.003a1.366 1.366 0 00-1.003-.413c-.394 0-.728.137-1.003.413-.276.275-.414.61-.414 1.003 0 .394.138.728.414 1.004zm2.066-4.545c0-.184.098-.361.295-.532.196-.17.433-.337.708-.501.275-.164.55-.354.826-.57.276-.217.512-.522.709-.916.196-.393.295-.852.295-1.377 0-1.036-.374-1.886-1.122-2.548-.747-.663-1.672-.994-2.774-.994-.63 0-1.24.148-1.83.443-.59.295-1.023.593-1.298.895l-.414.433 1.417 1.417a5.97 5.97 0 01.325-.295c.137-.119.393-.276.767-.473.374-.196.718-.295 1.033-.295.512 0 .935.144 1.27.433.334.289.5.617.5.984 0 .315-.147.6-.442.856-.295.256-.62.472-.974.649a3.054 3.054 0 00-.974.797 1.878 1.878 0 00-.442 1.24v.708h2.125v-.354z"
    />
  </Icon>
));

export { QuestionIcon };
